<template>
  <div class="pop-content">
    <div class="pop-title">申请数据</div>
    <br>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="研究名称" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入您的研究名称"></el-input>
      </el-form-item>
      <el-form-item label="研究目的" prop="purpose">
        <el-input type="textarea" v-model="ruleForm.purpose" placeholder="请输入您的研究目的"></el-input>
      </el-form-item>
      <el-form-item label="估计样本量及中心数" prop="centerNumber">
        <el-input type="textarea" v-model="ruleForm.centerNumber" placeholder="请输入您的估计样本量及中心数"></el-input>
      </el-form-item>

      <el-form-item label="申请中心" prop="center">
        <el-input v-model="ruleForm.center" placeholder="请输入您的中心"></el-input>
      </el-form-item>


      <el-form-item label="起止时间" required>
        <el-col :span="11">
          <el-form-item prop="startDate">
            <el-date-picker type="date" placeholder="请选择起始日期" v-model="ruleForm.startDate" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="1" style="text-align: center">-</el-col>
        <el-col :span="11">
          <el-form-item prop="endDate">
            <el-date-picker  type="date" placeholder="请选择起结束日期" v-model="ruleForm.endDate" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>


      <el-form-item label="申请人" prop="applicant">
        <el-input v-model="ruleForm.applicant" placeholder="请输入申请人"></el-input>
      </el-form-item>

      <el-form-item label="研究设计" prop="study">
        <el-input v-model="ruleForm.study" placeholder="请输入您的研究设计"></el-input>
      </el-form-item>

      <el-form-item label="研究对象" prop="object">
        <el-input type="textarea" v-model="ruleForm.object" placeholder="请输入您的研究对象"></el-input>
      </el-form-item>

      <el-form-item label="主要研究终点" prop="studyEnd">
        <el-input type="textarea" v-model="ruleForm.studyEnd" placeholder="请输入您的主要研究终点"></el-input>
      </el-form-item>

      <el-form-item label="次要研究终点" prop="secondaryStudyEnd">
        <el-input type="textarea" v-model="ruleForm.secondaryStudyEnd" placeholder="请输入您的次要研究终点"></el-input>
      </el-form-item>

      <el-form-item label="涉及数据字段名称" prop="fieldName">
        <el-input type="textarea" v-model="ruleForm.fieldName" placeholder="请输入您的字段名称"></el-input>
      </el-form-item>

      <el-form-item label="预期成果及完成时间" prop="expect">
        <el-input type="textarea" v-model="ruleForm.expect" placeholder="请输入预期成果及完成时间" ></el-input>
      </el-form-item>

      <el-form-item label="您的名字" prop="name">
        <el-input v-model="ruleForm.userName" placeholder="请输入您的名字"></el-input>
      </el-form-item>
      <el-form-item label="您的电话" prop="phone">
        <el-input v-model.number="ruleForm.phone" placeholder="请输入您的电话1"></el-input>
      </el-form-item>
      <el-form-item label="您的邮箱" prop="email">
        <el-input v-model="ruleForm.email" placeholder="请输入您的邮箱"></el-input>
      </el-form-item>




      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import Api from "../api";
// import { apply } from '../api/email/email.js'
export default {
name: "applicationData",
  data() {
    const checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字类型'));
      } else {
        if (value.toString().length === 11) {
          callback();
        } else {
          return callback(new Error('请输入11位手机号码'));
        }
      }
    }

    return {
      ruleForm: {
        name: '',
        purpose: '',
        centerNumber: '',
        center:'',
        startDate: null,
        endDate: null,
        applicant: '',
        study: '',
        object: '',
        studyEnd: '',
        secondaryStudyEnd: '',
        fieldName: '',
        expect: '',
        userName:'',
        phone:'',
        email:'',

      },
      rules: {
        name: [
          { required: true, message: '请输入您的研究名称', trigger: 'blur' },
        ],
        purpose: [
          { required: true, message: '请输入您的研究目的', trigger: 'blur' },
        ],
        centerNumber: [
          { required: true, message: '请输入您的估计样本量及中心数', trigger: 'blur' },
        ],
        center: [
          { required: true, message: '请输入您的中心', trigger: 'blur' },
        ],
        startDate: [
          { type:'date', required: true, message: '请选择起始日期', trigger: 'change' },
        ],
        endDate: [
          { type:'date', required: true, message: '请选择起结束日期', trigger: 'change' },
        ],
        applicant: [
          { required: true, message: '请输入申请人', trigger: 'blur' },
        ],
        study: [
          { required: true, message: '请输入您的研究设计', trigger: 'blur' },
        ],
        object: [
          { required: true, message: '请输入您的研究对象', trigger: 'blur' },
        ],
        studyEnd: [
          { required: true, message: '请输入您的主要研究终点', trigger: 'blur' },
        ],
        secondaryStudyEnd: [
          { required: true, message: '请输入您的次要研究终点', trigger: 'blur' },
        ],
        fieldName: [
          { required: true, message: '请输入您的字段名称', trigger: 'blur' },
        ],
        expect: [
          { required: true, message: '请输入预期成果及完成时间', trigger: 'blur' },
        ],
        phone: [
          {type: 'number', required: true, message: '请输入您的11位手机号', trigger: 'blur', validator: checkAge,},
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],

      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.applyData(this.ruleForm).then(result => {
            if(result.data.success){
              this.$message(result.data.message);
            }else{
              this.$message('发送失败，请稍后尝试');
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }

}
</script>

<style scoped>
/*@import url('../../static/css/swiper.min.css');*/
/*@import url('../../static/css/common.css');*/
/*@import url('../../static/css/index.css');*/
/*@import url('../../static/css/respond.css');*/
</style>



// WEBPACK FOOTER //
// src/components/applicationData.vue